import Chip from "@mui/material/Chip"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import { format } from "date-fns"
import { useEffect, useState } from "react"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import { adminApi } from "../axios"
import AdminLiquidSurface from "./AdminLiquidSurface"

export default function ZohoOrgConnectionPanel() {
  const [org, setOrg] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    adminApi
      .fetchZohoOrgConnection()
      .then(({ data }) => {
        if (!cancelled) setOrg(data)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (loading) {
    return (
      <AdminLiquidSurface variant="card" sx={{ p: 3 }}>
        <Typography color="text.secondary">Loading org connection…</Typography>
      </AdminLiquidSurface>
    )
  }

  if (!org) {
    return (
      <AdminLiquidSurface variant="card" sx={{ p: 3 }}>
        <Typography color="text.secondary">
          No Zoho Mail org connection found.
        </Typography>
      </AdminLiquidSurface>
    )
  }

  const fields = [
    ["ZOID", org.zoid],
    ["Domain", org.domain],
    ["Data center", org.data_center],
    ["Status", org.status],
    [
      "Connected at",
      org.connected_at ? format(new Date(org.connected_at), "PPpp") : "—",
    ],
    ["Connected by", org.connected_by_name || org.connected_by_email || "—"],
    [
      "Seats used / total",
      `${org.seats_used ?? "—"} / ${org.seats_total ?? "—"}`,
    ],
    [
      "Token expiry",
      org.token_expiry ? format(new Date(org.token_expiry), "PPpp") : "—",
    ],
    ["Last error", org.last_error || "—"],
  ]

  return (
    <AdminLiquidSurface variant="card" sx={{ p: 3 }}>
      <Column gap={2}>
        <Row gap={1} alignItems="center">
          <Typography variant="h6">Zoho Mail org connection</Typography>
          <Chip
            size="small"
            label={org.status || "unknown"}
            color={org.status === "connected" ? "success" : "default"}
          />
        </Row>
        <Grid container spacing={2}>
          {fields.map(([label, value]) => (
            <Grid item xs={12} sm={6} md={4} key={label}>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                {label}
              </Typography>
              <Typography variant="body2">{value || "—"}</Typography>
            </Grid>
          ))}
        </Grid>
      </Column>
    </AdminLiquidSurface>
  )
}
